<template>
  <naj-box :title="local.bankruptcy.activitiesForm.title">
    <v-row>
      <v-col
        cols="12"
        md="6"
        lg="3"
      >
        <naj-input
          :type-id="formFieldType.text"
          :label="local.bankruptcy.activitiesForm.activities"
          :value.sync="formModel.activities"
          validates="required|max:100"
          :disabled="isViewMode || (auditConfirmations[`flag_${mainRequestAuditFlag.bankruptActivitiesConfirmation}`] && isNotCompleted )"
        ></naj-input>
      </v-col>
      <v-col
        cols="12"
        md="6"
        lg="3"
      >
        <naj-input
          :type-id="formFieldType.selectbox"
          :label="local.bankruptcy.activitiesForm.activitiesStatus"
          :value.sync="formModel.status"
          :items="activitiesStatus"
          item-text="name"
          item-value="id"
          validates="required"
          :disabled="isViewMode || (auditConfirmations[`flag_${mainRequestAuditFlag.bankruptActivitiesConfirmation}`] && isNotCompleted )"
        ></naj-input>
      </v-col>
      <v-col
        cols="12"
        md="6"
      >
        <naj-input
          :type-id="formFieldType.date"
          :label="local.bankruptcy.activitiesForm.activitiesStartDate"
          :value.sync="formModel.activitiesStartDate"
          validates="required"
          :disabled="isViewMode || (auditConfirmations[`flag_${mainRequestAuditFlag.bankruptActivitiesConfirmation}`] && isNotCompleted )"
        ></naj-input>
      </v-col>
    </v-row>
    <v-row>
      <v-col
        v-if="formModel.status == activitiesStatusEnum.inActive"
        cols="12"
        md="6"
      >
        <naj-input
          :type-id="formFieldType.date"
          :label="local.bankruptcy.activitiesForm.activitiesEndDate"
          :value.sync="formModel.activitiesEndDate"
          validates="required"
          :disabled="isViewMode || (auditConfirmations[`flag_${mainRequestAuditFlag.bankruptActivitiesConfirmation}`] && isNotCompleted )"
        ></naj-input>
      </v-col>
      <v-col
        cols="12"
        md="6"
        lg="3"
      >
        <naj-input
          :type-id="formFieldType.number"
          :label="local.bankruptcy.activitiesForm.numberBranches"
          :value.sync="formModel.numberBranches"
          :disabled="isViewMode || (auditConfirmations[`flag_${mainRequestAuditFlag.bankruptActivitiesConfirmation}`] && isNotCompleted )"
        ></naj-input>
      </v-col>
      <v-col
        cols="12"
        md="6"
        lg="3"
      >
        <naj-input
          :type-id="formFieldType.text"
          :label="local.bankruptcy.activitiesForm.capital"
          :value.sync="formModel.capital"
          validates="required|decimal:2|min_value:0|max_number_length:20"
          :disabled="isViewMode || (auditConfirmations[`flag_${mainRequestAuditFlag.bankruptActivitiesConfirmation}`] && isNotCompleted )"
        ></naj-input>
      </v-col>
    </v-row>
    <v-row>
      <v-col
        cols="12"
        md="6"
        lg="3"
      >
        <naj-input
          :type-id="formFieldType.number"
          :label="local.bankruptcy.activitiesForm.numberCreditors"
          :value.sync="formModel.numberCreditors"
          validates="required"
          :disabled="isViewMode || (auditConfirmations[`flag_${mainRequestAuditFlag.bankruptActivitiesConfirmation}`] && isNotCompleted )"
        ></naj-input>
      </v-col>
      <v-col
        cols="12"
        md="6"
        lg="3"
      >
        <naj-input
          :type-id="formFieldType.text"
          :label="local.bankruptcy.activitiesForm.totalDebt"
          :value.sync="formModel.totalDebt"
          validates="required|decimal:2|min_value:0|max_number_length:20"
          :disabled="isViewMode || (auditConfirmations[`flag_${mainRequestAuditFlag.bankruptActivitiesConfirmation}`] && isNotCompleted )"
        ></naj-input>
      </v-col>
      <v-col
        cols="12"
        md="6"
        lg="3"
      >
        <naj-input
          :type-id="formFieldType.number"
          :label="local.bankruptcy.activitiesForm.numberDebtors"
          :value.sync="formModel.numberDebtors"
          validates="required"
          :disabled="isViewMode || (auditConfirmations[`flag_${mainRequestAuditFlag.bankruptActivitiesConfirmation}`] && isNotCompleted )"
        ></naj-input>
      </v-col>
      <v-col
        cols="12"
        md="6"
        lg="3"
      >
        <naj-input
          :type-id="formFieldType.text"
          :label="local.bankruptcy.activitiesForm.totalRights"
          :value.sync="formModel.totalRights"
          validates="required|decimal:2|min_value:0|max_number_length:20"
          :disabled="isViewMode || (auditConfirmations[`flag_${mainRequestAuditFlag.bankruptActivitiesConfirmation}`] && isNotCompleted )"
        ></naj-input>
      </v-col>
    </v-row>
    <v-row>
      <v-col
        cols="12"
        md="6"
        lg="3"
      >
        <naj-input
          :type-id="formFieldType.number"
          :label="local.bankruptcy.activitiesForm.numberEmployees"
          :value.sync="formModel.numberEmployees"
          validates="required"
          :disabled="isViewMode || (auditConfirmations[`flag_${mainRequestAuditFlag.bankruptActivitiesConfirmation}`] && isNotCompleted )"
        ></naj-input>
      </v-col>
      <v-col
        cols="12"
        md="6"
        lg="3"
      >
        <naj-input
          :type-id="formFieldType.text"
          :label="local.bankruptcy.activitiesForm.totalAsset"
          :value.sync="formModel.totalAsset"
          validates="required|decimal:2|min_value:0|max_number_length:20"
          :disabled="isViewMode || (auditConfirmations[`flag_${mainRequestAuditFlag.bankruptActivitiesConfirmation}`] && isNotCompleted )"
        ></naj-input>
      </v-col>
    </v-row>
    <v-row>
      <v-col cols="12">
        <naj-input
          :type-id="formFieldType.textarea"
          :label="local.bankruptcy.activitiesForm.moneyStoragePlace"
          :value.sync="formModel.moneyStoragePlace"
          :disabled="isViewMode || (auditConfirmations[`flag_${mainRequestAuditFlag.bankruptActivitiesConfirmation}`] && isNotCompleted )"
          validates="required"
        ></naj-input>
      </v-col>
    </v-row>
    <v-row>
      <v-col cols="6">
        <audit-confirmation-flag-checkbox :audit-flag="mainRequestAuditFlag.bankruptActivitiesConfirmation"></audit-confirmation-flag-checkbox>
      </v-col>
    </v-row>
    <v-row>
      <v-col cols="12">
        <naj-input
          :type-id="formFieldType.textarea"
          :label="local.bankruptcy.activitiesForm.overviewDebtorFinancialPosition"
          :value.sync="formModel.overviewDebtorFinancialPosition"
          :disabled="isViewMode || (auditConfirmations[`flag_${mainRequestAuditFlag.debtorFinancialPositionConfirmation}`] && isNotCompleted )"
          validates="required"
        ></naj-input>
      </v-col>
    </v-row>
    <v-row>
      <v-col cols="6">
        <audit-confirmation-flag-checkbox :audit-flag="mainRequestAuditFlag.debtorFinancialPositionConfirmation"></audit-confirmation-flag-checkbox>
      </v-col>
    </v-row>
  </naj-box>
</template>

<script>
import { createNamespacedHelpers } from 'vuex';
const { mapState, mapGetters, mapActions } = createNamespacedHelpers('BankruptcyModule');
import { activitiesStatusEnum, mainRequestAuditFlag, requestStatusEnum } from '@/modules/bankruptcy/helpers/enum';
import AuditConfirmationFlagCheckbox from '@/modules/bankruptcy/components/request/audit-confirmation-flag-checkbox';
export default {
  name: 'ActivitiesForm',
  inject: ['$validator'],
  components: { AuditConfirmationFlagCheckbox },
  data() {
    return {
      isDisabled: true,
      activitiesStatusEnum,
      mainRequestAuditFlag,
      requestStatusEnum,
    };
  },
  computed: {
    ...mapState({
      formModel: state => state.activities,
      activitiesStatus: state => state.activitiesStatus,
      auditConfirmations: state => state.auditConfirmations,
    }),
    ...mapGetters([
      'isViewMode',
      'isNewMode',
      'isEditMode',
      'isNotCompleted',
    ]),
    requestObjectKey() {
      return this.$route.params.objectKey;
    },
  },
  created() {
    this.getBankruptActivities(this.requestObjectKey);
  },
  methods: {
    ...mapActions([
      'getBankruptActivities',
    ]),
  },
};
</script>

<style lang="scss">
</style>
